export const TWITTER_URL = "https://twitter.com/focusonflare";
export const TELEGRAM_URL = "https://t.me/+4M2l8_kQljg3MTBk";
